import { Grid, makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import EmployeeCardV2 from './EmployeeListV2';
import JourneyCardV2 from './JourneyCardV2';
import { TabStyledContent } from '../common/Tab';

const useStyles = makeStyles(() => ({
  scrollableContent: {
    maxHeight: '55vh',
    overflowY: 'auto',
    overflowX: 'hidden',
    width: '41.5vw',
    '&::-webkit-scrollbar': { width: '10px' },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 5px grey',
      borderRadius: '20px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'lightGrey',
      borderRadius: '100px',
    },
  },
}));

export default function EmployeeJourneyTabContent({
  tabValue,
  setTabValue,
  refreshData,
  selectedDep,
  selectedRole,
  flow = 'rule',
  showJourneyAddIcon = false,
}) {
  const classes = useStyles();

  const employeeListRedux = useSelector((state) => state.GetEmployeeList.employeelist);
  const dealershipDetails = useSelector((state) => state.DealershipDetails.dealershipdetails);

  const [tabs, setTabs] = useState();

  useEffect(() => {
    if (flow !== 'group') {
      setTabs([
        { label: `Employees (${employeeListRedux?.length || 0})`, index: 0 },
        { label: `Journeys (${dealershipDetails?.assignedJourneyCount || 0})`, index: 1 },
      ]);
    } else {
      setTabs([{ label: `Employees (${employeeListRedux?.length || 0})`, index: 0 }]);
    }
  }, [flow, employeeListRedux, dealershipDetails?.assignedJourneyCount]);

  return (
    <>
      <Grid container style={{ maxWidth: '100%' }}>
        <div style={{ marginLeft: '10px', marginRight: '10px', width: '100%' }}>
          <TabStyledContent tabValue={tabValue} setTabValue={setTabValue} tabs={tabs} />
        </div>
      </Grid>
      <div className={classes.scrollableContent}>
        {tabValue === 0 ? (
          <EmployeeCardV2 refreshData={refreshData} selectedDep={selectedDep} selectedRole={selectedRole} />
        ) : (
          <JourneyCardV2 flow={flow} showJourneyAddIcon={showJourneyAddIcon} />
        )}
      </div>
    </>
  );
}
